// Base
import Head from 'next/head'

// Components
import MainLayout from '@components/v25/es/MainLayout'

// Sections
import MembershipWrapper from '@sections/v25/es/ft1/membership/MembershipWrapper'
import MoneyBackGuarantee from '@sections/v25/es/money-back-guarantee/MoneyBackGuarantee'
import CustomerReview from '@sections/v25/es/ft1/membership/customer-review/CustomerReview'
import FAQ from '@components/v25/es/faq/FAQ'
import FullRefundText from '@components/v25/es/ft1/full-refund-text/FullRefundText'

export default function Membership() {
  return (
    <>
      <Head>
        <title>RatePunk Premium | Membership</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <MainLayout backgroundColor="#FCF8FC" displayCounter>
        <MembershipWrapper />

        <MoneyBackGuarantee />

        <FullRefundText />

        <CustomerReview />

        <FAQ theme="black" padding={[32, 0]} />
      </MainLayout>
    </>
  )
}
